import { render, staticRenderFns } from "./block-news-carousel.vue?vue&type=template&id=7fdf862a&scoped=true&"
import script from "./block-news-carousel.vue?vue&type=script&lang=js&"
export * from "./block-news-carousel.vue?vue&type=script&lang=js&"
import style0 from "./block-news-carousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./block-news-carousel.vue?vue&type=style&index=1&id=7fdf862a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf862a",
  null
  
)

export default component.exports